const servicesUtils = require('utils/Services');
const shouldServiceRun = servicesUtils.shouldServiceRun;
const store = require('Store');
const BasketActions = require('actions/BasketActions');

module.exports = (function () {
    // Stop service from loading if not necessary
    if (!shouldServiceRun.refreshBasket()) {
        return;
    }

    Sephora.Util.InflatorComps.services.RefreshBasketService = () => {
        store.dispatch(BasketActions.refreshBasket(true));
    };
}());
